module.exports = __webpack_public_path__ + "img/KOREA.fd2c0196.jpg";